import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Inbox from './views/Inbox.vue'
import Categories from './views/Categories.vue'
import MediaView from './views/MediaView.vue'
import EditMediaPage from './views/EditMediaPage.vue'
import Affiliates from './views/Affiliates.vue'
import PromoCodes from './views/PromoCodes.vue'
import Partners from './views/Partners.vue'
import Finance from './views/Finance.vue'
import Stats from './views/Stats.vue'
import Users from './views/Users.vue'
import Ddex from './views/Ddex.vue'
import PPVTiers from './views/PPVTiers.vue'
import PPVPackages from './views/PPVPackages.vue'
import FAQ from './views/FAQ.vue'
import Documents from './views/Documents.vue'
import PurchaseTexts from './views/PurchaseTexts.vue'
import LoginTexts from './views/LoginTexts.vue'
import ManualEntitlements from './views/ManualEntitlements.vue'
import Currencies from './views/Currencies.vue'
import RssFeeds from './views/RssFeeds.vue'
import FlexSubscriptions from './views/FlexSubscriptions.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/inbox',
      name: 'inbox',
      component: Inbox
    },
    {
      path: '/categories',
      name: 'categories',
      component: Categories
    },
    {
      path: '/media',
      name: 'media',
      component: MediaView
    },
    {
      path: '/media/:id',
      name: 'edit-media',
      component: EditMediaPage
    },
    {
      path: '/affiliates',
      name: 'affiliates',
      component: Affiliates
    },
    {
      path: '/promo-codes',
      name: 'promo-codes',
      component: PromoCodes
    },
    {
      path: '/partners',
      name: 'partners',
      component: Partners
    },
    {
      path: '/finance',
      name: 'finance',
      component: Finance
    },
    {
      path: '/stats',
      name: 'stats',
      component: Stats
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/ddex-import',
      name: 'ddex-import',
      component: Ddex
    },
    {
      path: '/ppv-tiers',
      name: 'ppv-tiers',
      component: PPVTiers
    },
    {
      path: '/ppv-packages',
      name: 'ppv-packages',
      component: PPVPackages
    },
    {
      path: '/purchase-texts',
      name: 'purchase-texts',
      component: PurchaseTexts
    },
    {
      path: '/login-texts',
      name: 'login-texts',
      component: LoginTexts
    },
    {
      path: '/manual-entitlements',
      name: 'manual-entitlements',
      component: ManualEntitlements
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQ
    },
    {
      path: '/documents',
      name: 'documents',
      component: Documents
    },
    {
      path: '/currencies',
      name: 'currencies',
      component: Currencies
    },
    {
      path: '/rss-feeds',
      name: 'rss-feeds',
      component: RssFeeds
    },
    {
      path: '/flex-subscriptions',
      name: 'flex-subscriptions',
      component: FlexSubscriptions
    },
  ]
})
